(function () {
  'use strict';

  var LABELS = {
    zone: {helix:'Helix',tragus:'Tragus',conch:'Conch',daith:'Daith',rook:'Rook',lobe:'Lobe',flat:'Flat',neus:'Neus',septum:'Septum',lip:'Lip',wenkbrauw:'Wenkbrauw',navel:'Navel',tepel:'Tepel',tong:'Tong',industrial:'Industrial',dermal:'Dermal / surface',onderdelen:'Onderdelen'},
    type: {labret:'Labret / stud',ring:'Ring / clicker',barbell:'Barbell',hanger:'Met hanger',onderdeel:'Onderdeel'},
    gauge: {'20':'20G · 0,8 mm','16':'16G · 1,2 mm','14':'14G · 1,6 mm'},
    col: {zilver:'Zilver / titanium',goud:'Goud',zwart:'Zwart',rose:'Roségoud',roze:'Roze',rood:'Rood',blauw:'Blauw',wit:'Wit',multicolor:'Multicolor'}
  };
  var COLORS = {zilver:'#c9cfd6',goud:'#d4af4f',zwart:'#2e3033',rose:'#e2a28f',roze:'#f2a6c4',rood:'#c2323a',blauw:'#4a7bc7',wit:'#f4f4f4',multicolor:'linear-gradient(90deg,#f66,#fc6,#6c6,#66f)'};
  var MAP_OF = {helix:'oor',tragus:'oor',conch:'oor',daith:'oor',rook:'oor',lobe:'oor',flat:'oor',neus:'gezicht',septum:'gezicht',lip:'gezicht',wenkbrauw:'gezicht',tong:'gezicht',navel:'lichaam',tepel:'lichaam',dermal:'lichaam',industrial:'lichaam',onderdelen:'lichaam'};

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>'"]/g, function (character) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#039;','"':'&quot;'}[character];
    });
  }

  function init(root) {
    if (!root || root.dataset.eipcReady === 'true') return;
    root.dataset.eipcReady = 'true';
    document.body.classList.add('eipc-active');

    var META = window.EIPC_META || {};
    var grid = root.querySelector('[data-product-grid]');
    var bundle = root.querySelector('[data-bundle]');
    var empty = root.querySelector('[data-empty]');
    var more = root.querySelector('[data-more]');
    var overlay = root.querySelector('[data-overlay]');
    var filterPanel = root.querySelector('[data-filter-panel]');
    var sortPanel = root.querySelector('[data-sort-panel]');
    var cartDrawer = root.querySelector('[data-cart-drawer]');
    var sizeDialog = root.querySelector('[data-size-dialog]');
    var productDialog = root.querySelector('[data-product-dialog]');
    var productPreviewContent = root.querySelector('[data-product-preview-content]');
    var toastElement = root.querySelector('[data-toast]');
    var totalPages = Number(root.dataset.totalPages || 1);
    var totalProducts = Number(root.dataset.totalProducts || 0);
    var freeShipping = Number(root.dataset.freeShippingCents || 10000);
    var shippingCost = Number(root.dataset.shippingCostCents || 395);
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'nl-NL';
    var pageSize = 24;
    var shown = pageSize;
    var allPagesLoaded = totalPages <= 1;
    var toastTimer;
    var announcementTimer;
    var productCache = {};
    var currentCart = null;
    var mobileMedia = window.matchMedia('(max-width: 989px)');
    var state = {zone:new Set(),type:new Set(),gauge:new Set(),len:new Set(),col:new Set(),fresh:false,stock:true,min:null,max:null,search:'',sort:'best'};

    function money(cents) {
      try {
        return new Intl.NumberFormat(locale, {style:'currency', currency:currency}).format((Number(cents) || 0) / 100);
      } catch (error) {
        return '€' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
      }
    }

    function amount(cents) {
      return Number(((Number(cents) || 0) / 100).toFixed(2));
    }

    function eventId(name) {
      var suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
      return 'eipc-' + String(name || 'event').toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + suffix;
    }

    function trackingItemFromCart(item) {
      item = item || {};
      var itemHandle = item.handle || (String(item.url || '').match(/\/products\/([^?]+)/) || [])[1] || '';
      var metadata = META[itemHandle] || {};
      var unitCents = Number(item.final_price || item.price || item.original_price || 0);
      return {
        item_id:String(item.variant_id || item.id || item.product_id || itemHandle),
        item_name:metadata.name || item.product_title || item.title || itemHandle || 'Piercing',
        item_brand:item.vendor || 'Empire Ink',
        item_category:'Piercing',
        item_variant:item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : undefined,
        price:amount(unitCents),
        quantity:Number(item.quantity || 1)
      };
    }

    function trackingItemFromCard(card, variantId) {
      if (!card) return null;
      var metadata = cardMeta(card);
      var title = metadata.name || (card.querySelector('[data-card-title]') || {}).textContent || card.dataset.handle || 'Piercing';
      var button = card.querySelector('[data-variant-id]');
      return {
        item_id:String(variantId || (button && button.dataset.variantId) || card.dataset.handle),
        item_name:String(title).trim(),
        item_brand:'Empire Ink',
        item_category:'Piercing',
        price:amount(card.dataset.priceCents),
        quantity:1
      };
    }

    function trackingItemFromProduct(product, card, variantId) {
      product = product || {};
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var variant = variants.find(function (candidate) { return String(candidate.id) === String(variantId); })
        || variants.find(function (candidate) { return candidate.available; })
        || variants[0]
        || {};
      var metadata = card ? cardMeta(card) : {};
      return {
        item_id:String(variant.id || product.id || product.handle || ''),
        item_name:metadata.name || product.title || product.handle || 'Piercing',
        item_brand:product.vendor || 'Empire Ink',
        item_category:'Piercing',
        item_variant:variant.public_title || (variant.title !== 'Default Title' ? variant.title : undefined),
        price:amount(variant.price || product.price || 0),
        quantity:1
      };
    }

    function productEventData(item, ga4Name, metaName, extra) {
      item = item || {item_id:'', item_name:'Piercing', item_brand:'Empire Ink', item_category:'Piercing', price:0, quantity:1};
      var quantity = Number(item.quantity || 1);
      var value = Number((Number(item.price || 0) * quantity).toFixed(2));
      return Object.assign({
        ga4_event:ga4Name,
        meta_event:metaName || undefined,
        currency:currency,
        value:value,
        content_type:'product',
        content_ids:[String(item.item_id || '')],
        content_name:item.item_name,
        contents:[{id:String(item.item_id || ''), quantity:quantity, item_price:Number(item.price || 0)}],
        items:[item],
        ecommerce:{currency:currency, value:value, items:[item]}
      }, extra || {});
    }

    function cartEventData(cart, ga4Name, metaName, extra) {
      cart = cart || {};
      var eventItems = (cart.items || []).map(trackingItemFromCart);
      var value = amount(cart.total_price || 0);
      return Object.assign({
        ga4_event:ga4Name,
        meta_event:metaName || undefined,
        currency:currency,
        value:value,
        item_count:Number(cart.item_count || 0),
        content_type:'product',
        content_ids:eventItems.map(function (item) { return String(item.item_id); }),
        contents:eventItems.map(function (item) { return {id:String(item.item_id), quantity:Number(item.quantity || 1), item_price:Number(item.price || 0)}; }),
        items:eventItems,
        ecommerce:{currency:currency, value:value, items:eventItems}
      }, extra || {});
    }

    function track(name, data) {
      var details = Object.assign({}, data || {});
      var id = details.event_id || eventId(name);
      details.event_id = id;
      details.eventID = id;
      var payload = Object.assign({
        event:name,
        microsite:'empire-piercings-collectie',
        page_path:location.pathname
      }, details);
      window.dataLayer = window.dataLayer || [];
      if (payload.ecommerce) window.dataLayer.push({ecommerce:null});
      window.dataLayer.push(payload);
      return id;
    }

    function toast(message) {
      if (!toastElement) return;
      toastElement.textContent = message;
      toastElement.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastElement.classList.remove('is-visible'); }, 2300);
    }

    function cards() {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    }

    function stars(value) {
      var count = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
      return '★★★★★'.slice(0, count) + '☆☆☆☆☆'.slice(0, 5 - count);
    }

    function fallbackMeta(card) {
      var title = card.querySelector('[data-card-title]');
      var text = title ? title.textContent.trim() : card.dataset.handle;
      return {name:text,sub:'',zone:[],type:'',gauge:'',len:[],col:[],fresh:0,badge:'',rating:0,n:0,id:9999};
    }

    function cardMeta(card) {
      return META[card.dataset.handle] || fallbackMeta(card);
    }

    function decorateCard(card) {
      if (card.dataset.decorated === 'true') return;
      var meta = cardMeta(card);
      var title = card.querySelector('[data-card-title]');
      var sub = card.querySelector('[data-card-sub]');
      var rating = card.querySelector('[data-card-rating]');
      var badges = card.querySelector('[data-card-badges]');
      var swatches = card.querySelector('[data-card-swatches]');
      var material = card.querySelector('.eipc-material');
      if (title && meta.name) title.textContent = meta.name;
      if (sub) sub.textContent = meta.sub || '';
      if (rating && meta.rating) rating.innerHTML = '<b>' + stars(meta.rating) + '</b> ' + String(meta.rating).replace('.', ',') + ' (' + (meta.n || 0) + ')';
      if (badges && meta.badge) badges.innerHTML = '<span class="eipc-badge' + (meta.badge === 'Nieuw' ? ' is-new' : '') + '">' + escapeHtml(meta.badge) + '</span>';
      if (swatches) {
        var colors = Array.isArray(meta.col) ? meta.col : [];
        swatches.innerHTML = colors.map(function (color) {
          return '<i class="eipc-swatch" title="' + escapeHtml(LABELS.col[color] || color) + '" style="background:' + (COLORS[color] || '#ddd') + '"></i>';
        }).join('') + ((meta.len || []).length > 1 ? '<small>' + meta.len.length + ' maten</small>' : '');
      }
      if (material && (meta.fin === 'au' || meta.fin === 'ro')) material.textContent = 'Titanium · nikkelvrij · goudkleurig';
      card.dataset.metaId = String(meta.id || 9999);
      card.dataset.decorated = 'true';
    }

    function activeFilterCount() {
      return state.zone.size + state.type.size + state.gauge.size + state.len.size + state.col.size + (state.fresh ? 1 : 0) + (state.min != null ? 1 : 0) + (state.max != null ? 1 : 0);
    }

    function hasAny(array, selected) {
      if (!selected.size) return true;
      return (array || []).some(function (value) { return selected.has(String(value)); });
    }

    function matches(card) {
      var meta = cardMeta(card);
      if (!hasAny(meta.zone, state.zone)) return false;
      if (state.type.size && !state.type.has(String(meta.type || ''))) return false;
      if (state.gauge.size && !state.gauge.has(String(meta.gauge || ''))) return false;
      if (!hasAny(meta.len, state.len)) return false;
      if (!hasAny(meta.col, state.col)) return false;
      if (state.fresh && !meta.fresh) return false;
      if (state.stock && card.dataset.available !== 'true') return false;
      var price = Number(card.dataset.priceCents || 0) / 100;
      if (state.min != null && price < state.min) return false;
      if (state.max != null && price > state.max) return false;
      if (state.search) {
        var haystack = [meta.name, meta.sub, card.dataset.handle].concat(meta.zone || []).join(' ').toLowerCase();
        if (haystack.indexOf(state.search) === -1) return false;
      }
      return true;
    }

    function compare(a, b) {
      var x = cardMeta(a);
      var y = cardMeta(b);
      if (state.sort === 'asc') return Number(a.dataset.priceCents) - Number(b.dataset.priceCents);
      if (state.sort === 'desc') return Number(b.dataset.priceCents) - Number(a.dataset.priceCents);
      if (state.sort === 'rating') return (Number(y.rating) - Number(x.rating)) || (Number(y.n) - Number(x.n));
      if (state.sort === 'new') return Number(y.badge === 'Nieuw') - Number(x.badge === 'Nieuw') || Number(a.dataset.metaId) - Number(b.dataset.metaId);
      return Number(y.badge === 'Bestseller') - Number(x.badge === 'Bestseller') || Number(y.n || 0) - Number(x.n || 0) || Number(a.dataset.metaId) - Number(b.dataset.metaId);
    }

    function labelFor(kind, value) {
      if (kind === 'len') return String(value).replace('.', ',') + ' mm';
      return (LABELS[kind] && LABELS[kind][value]) || value;
    }

    function updateChips() {
      var chips = root.querySelector('[data-chips]');
      if (!chips) return;
      var html = '';
      ['zone','type','gauge','len','col'].forEach(function (kind) {
        state[kind].forEach(function (value) {
          html += '<span class="eipc-chip">' + escapeHtml(labelFor(kind, value)) + '<button type="button" data-chip-kind="' + kind + '" data-chip-value="' + escapeHtml(value) + '">×</button></span>';
        });
      });
      if (state.fresh) html += '<span class="eipc-chip">Verse piercing<button type="button" data-chip-kind="fresh">×</button></span>';
      if (state.search) html += '<span class="eipc-chip">“' + escapeHtml(state.search) + '”<button type="button" data-chip-kind="search">×</button></span>';
      if (html) html += '<button class="eipc-chip" type="button" data-clear>Alles wissen</button>';
      chips.innerHTML = html;
      chips.hidden = !html;
    }

    function syncControls() {
      root.querySelectorAll('[data-filter-field]').forEach(function (input) {
        var kind = input.dataset.filterField;
        if (kind === 'fresh') input.checked = state.fresh;
        else if (kind === 'stock') input.checked = state.stock;
        else input.checked = state[kind].has(input.value);
      });
      root.querySelectorAll('[data-zone]').forEach(function (button) { button.classList.toggle('is-active', state.zone.has(button.dataset.zone)); });
      var badge = root.querySelector('[data-filter-badge]');
      var count = activeFilterCount();
      if (badge) { badge.textContent = count; badge.hidden = count === 0; }
      var min = root.querySelector('[data-price-min]');
      var max = root.querySelector('[data-price-max]');
      if (min && document.activeElement !== min) min.value = state.min == null ? '' : state.min;
      if (max && document.activeElement !== max) max.value = state.max == null ? '' : state.max;
      var crumb = root.querySelector('[data-crumb-zone]');
      if (crumb) {
        var selectedZones = Array.from(state.zone);
        crumb.textContent = selectedZones.length === 1 ? (LABELS.zone[selectedZones[0]] || selectedZones[0]) : 'Alle sieraden';
      }
    }

    function syncResponsiveLayout() {
      root.querySelectorAll('[data-footer-details]').forEach(function (details) {
        details.open = !mobileMedia.matches;
      });
    }

    function startAnnouncement() {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-announcement-item]'));
      if (!items.length) return;
      var index = 0;
      items[0].classList.add('is-current');
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(announcementTimer);
      announcementTimer = setInterval(function () {
        items[index].classList.remove('is-current');
        index = (index + 1) % items.length;
        items[index].classList.add('is-current');
      }, 3600);
    }

    function applyFilters(resetShown) {
      if (resetShown !== false) shown = pageSize;
      var list = cards();
      list.forEach(decorateCard);
      var filtered = list.filter(matches).sort(compare);
      var visible = filtered.slice(0, shown);
      var bundleIndex = mobileMedia.matches ? 4 : 6;
      list.forEach(function (card) { card.hidden = true; });
      filtered.forEach(function (card, index) {
        card.hidden = index >= shown;
        grid.appendChild(card);
      });
      if (bundle) {
        bundle.hidden = filtered.length === 0;
        if (visible.length > bundleIndex) grid.insertBefore(bundle, visible[bundleIndex]);
        else if (visible.length) grid.insertBefore(bundle, more);
      }
      if (empty) { empty.hidden = filtered.length !== 0; grid.appendChild(empty); }
      if (more) {
        var canShowMore = filtered.length > shown;
        more.hidden = !canShowMore && allPagesLoaded;
        var shownCount = root.querySelector('[data-shown-count]');
        var moreTotal = root.querySelector('[data-more-total]');
        var moreButton = root.querySelector('[data-show-more]');
        if (shownCount) shownCount.textContent = Math.min(shown, filtered.length);
        if (moreTotal) moreTotal.textContent = allPagesLoaded ? filtered.length : totalProducts;
        if (moreButton) moreButton.textContent = allPagesLoaded ? 'Toon meer sieraden' : 'Producten laden…';
        grid.appendChild(more);
      }
      var resultCount = root.querySelector('[data-result-count]');
      var applyCount = root.querySelector('[data-apply-count]');
      var displayCount = allPagesLoaded || activeFilterCount() || state.search ? filtered.length : totalProducts;
      if (resultCount) resultCount.textContent = displayCount;
      if (applyCount) applyCount.textContent = displayCount;
      updateChips();
      syncControls();
    }

    function clearFilters() {
      ['zone','type','gauge','len','col'].forEach(function (kind) { state[kind].clear(); });
      state.fresh = false;
      state.stock = true;
      state.min = null;
      state.max = null;
      state.search = '';
      root.querySelectorAll('[data-search]').forEach(function (input) { input.value = ''; });
      applyFilters();
      track('eipc_filters_clear');
    }

    function buildCounts() {
      root.querySelectorAll('[data-filter-count]').forEach(function (element) {
        var parts = element.dataset.filterCount.split(':');
        var kind = parts[0];
        var value = parts.slice(1).join(':');
        var count = Object.keys(META).reduce(function (sum, handle) {
          var meta = META[handle] || {};
          var candidate = meta[kind];
          var hit = Array.isArray(candidate) ? candidate.map(String).indexOf(value) !== -1 : String(candidate || '') === value;
          return sum + (hit ? 1 : 0);
        }, 0);
        element.textContent = count ? String(count) : '';
        var label = element.closest('label');
        if (label) label.hidden = count === 0;
      });
    }

    function openPanel(panel) {
      closePanels(false);
      if (!panel) return;
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      document.documentElement.classList.add('eipc-lock');
    }

    function closePanels(clearOverlay) {
      [filterPanel, sortPanel, cartDrawer].forEach(function (panel) {
        if (!panel) return;
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
      });
      if (clearOverlay !== false) {
        overlay.classList.remove('is-open');
        document.documentElement.classList.remove('eipc-lock');
      }
    }

    function showMap(name) {
      root.querySelectorAll('[data-map-tab]').forEach(function (button) {
        var active = button.dataset.mapTab === name;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      root.querySelectorAll('[data-map-panel]').forEach(function (panel) {
        var active = panel.dataset.mapPanel === name;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    }

    async function loadAllPages() {
      if (allPagesLoaded) return;
      var sectionId = root.dataset.sectionId;
      for (var page = 2; page <= totalPages; page += 1) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('page', String(page));
          url.searchParams.set('section_id', sectionId);
          var response = await fetch(url.toString(), {headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('page');
          var html = await response.text();
          var documentPage = new DOMParser().parseFromString(html, 'text/html');
          documentPage.querySelectorAll('[data-product-card]').forEach(function (card) {
            if (!grid.querySelector('[data-handle="' + CSS.escape(card.dataset.handle) + '"]')) {
              var imported = document.importNode(card, true);
              grid.insertBefore(imported, bundle || more);
              decorateCard(imported);
            }
          });
        } catch (error) {
          toast('Niet alle producten konden worden geladen. Vernieuw de pagina.');
          break;
        }
      }
      allPagesLoaded = cards().length >= totalProducts || totalPages <= 1;
      applyFilters(false);
    }

    async function loadCart(openAfter) {
      var items = root.querySelector('[data-cart-items]');
      try {
        var response = await fetch(root.dataset.cartUrl, {headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        var cart = await response.json();
        currentCart = cart;
        var itemCount = Number(cart.item_count || 0);
        var originalTotal = Number(cart.original_total_price || cart.total_price || 0);
        var cartTotal = Number(cart.total_price || 0);
        var discountTotal = Number(cart.total_discount || Math.max(0, originalTotal - cartTotal));
        var shipping = itemCount ? (cartTotal >= freeShipping ? 0 : shippingCost) : 0;
        var estimatedTotal = cartTotal + shipping;
        var now = new Date();
        var cutoff = String(root.dataset.shippingCutoff || '16:30').split(':');
        var cutoffDate = new Date(now);
        cutoffDate.setHours(Number(cutoff[0] || 16), Number(cutoff[1] || 30), 0, 0);
        var shipsToday = now < cutoffDate && now.getDay() !== 0;
        var handleOf = function (item) {
          if (item.handle) return item.handle;
          var match = String(item.url || '').match(/\/products\/([^?]+)/);
          return match ? match[1] : '';
        };
        var jewelryCount = (cart.items || []).reduce(function (count, item) {
          var metadata = META[handleOf(item)] || {};
          return count + (metadata.type === 'onderdeel' ? 0 : Number(item.quantity || 0));
        }, 0);
        root.querySelectorAll('[data-cart-count]').forEach(function (element) { element.textContent = cart.item_count || 0; });
        root.querySelectorAll('[data-cart-count-label]').forEach(function (element) { element.textContent = itemCount ? '(' + itemCount + ')' : ''; });
        root.querySelectorAll('[data-cart-total]').forEach(function (element) { element.textContent = money(cart.total_price || 0); });
        var mobileCart = root.querySelector('[data-mobile-cart]');
        var mobileCartNote = root.querySelector('[data-mobile-cart-note]');
        if (mobileCart) mobileCart.classList.toggle('has-items', Number(cart.item_count || 0) > 0);
        if (mobileCartNote) {
          if (!cart.item_count) mobileCartNote.textContent = 'Nog leeg · 3 sieraden = 10% korting';
          else if (cart.item_count === 1) mobileCartNote.textContent = 'Nog 1 sieraad voor 5% setkorting';
          else if (cart.item_count === 2) mobileCartNote.textContent = 'Nog 1 sieraad voor 10% setkorting';
          else mobileCartNote.textContent = '10% setkorting bij automatische korting';
        }
        var subtotal = root.querySelector('[data-cart-subtotal]');
        if (subtotal) subtotal.textContent = money(originalTotal);
        root.querySelectorAll('[data-cart-summary-count]').forEach(function (element) { element.textContent = itemCount; });
        root.querySelectorAll('[data-cart-discount]').forEach(function (element) { element.textContent = '−' + money(discountTotal); });
        root.querySelectorAll('[data-cart-discount-row]').forEach(function (element) { element.hidden = discountTotal <= 0; });
        root.querySelectorAll('[data-cart-shipping]').forEach(function (element) {
          element.innerHTML = !itemCount ? '—' : shipping === 0 ? '<span class="eipc-cart-free">Gratis</span>' : money(shipping);
        });
        root.querySelectorAll('[data-cart-estimated-total]').forEach(function (element) { element.textContent = money(estimatedTotal); });
        var remaining = Math.max(0, freeShipping - cartTotal);
        var shipText = root.querySelector('[data-shipping-text]');
        var shipBar = root.querySelector('[data-shipping-bar]');
        var shippingBox = shipText ? shipText.closest('.eipc-shipping') : null;
        if (shippingBox) shippingBox.classList.toggle('is-free', itemCount > 0 && remaining === 0);
        if (shipText) shipText.innerHTML = !itemCount ? 'Gratis verzending vanaf <b>' + money(freeShipping) + '</b>' : remaining > 0 ? 'Nog <b>' + money(remaining) + '</b> tot gratis verzending' : '<b>Je verzending is gratis.</b> ' + (shipsToday ? 'Vandaag verzonden' : 'Volgende werkdag verzonden');
        if (shipBar) shipBar.style.width = Math.min(100, freeShipping ? (cartTotal / freeShipping) * 100 : 100) + '%';
        var setText = root.querySelector('[data-cart-set-text]');
        if (setText) {
          if (jewelryCount >= 3) setText.innerHTML = '<b>10% setkorting actief</b>' + (discountTotal ? ' · je bespaart ' + money(discountTotal) : '');
          else if (jewelryCount === 2) setText.innerHTML = '<b>Nog 1 sieraad</b> voor 10% setkorting (nu 5%)';
          else if (jewelryCount === 1) setText.innerHTML = '<b>Nog 1 sieraad</b> voor 5% setkorting, 3 sieraden = 10%';
          else setText.textContent = 'Combineer: 2 sieraden = 5% · 3 of meer = 10% korting';
        }
        root.querySelectorAll('[data-cart-set-dot]').forEach(function (dot) {
          dot.classList.toggle('is-active', jewelryCount >= Number(dot.dataset.cartSetDot || 0));
        });
        if (!cart.items || !cart.items.length) {
          items.innerHTML = '<div class="eipc-cart-empty"><h3>Je winkelwagen is nog leeg</h3><p>Kies een plek en we tonen alleen sieraden in de juiste maat.</p><button type="button" data-cart-close>Verder winkelen</button></div>';
        } else {
          items.innerHTML = cart.items.map(function (item, index) {
            var image = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image || '';
            var metadata = META[handleOf(item)] || {};
            var title = metadata.name || item.product_title || item.title;
            var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="eipc-cart-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
            var originalLine = Number(item.original_line_price || item.line_price || 0);
            var finalLine = Number(item.final_line_price || item.line_price || 0);
            var price = '<div class="eipc-cart-price">' + money(finalLine) + (originalLine > finalLine ? '<s>' + money(originalLine) + '</s>' : '') + '</div>';
            return '<article class="eipc-cart-line">' + (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '">' : '<div class="eipc-cart-image"></div>') + '<div><h4>' + escapeHtml(title) + '</h4>' + variant + '<div class="eipc-cart-stock">Op voorraad · ' + (shipsToday ? 'vandaag verzonden' : 'volgende werkdag verzonden') + '</div><div class="eipc-qty"><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Minder">−</button><span>' + item.quantity + '</span><button type="button" data-cart-line="' + (index + 1) + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="Meer">+</button></div></div>' + price + '</article>';
          }).join('');
        }
        var upsell = root.querySelector('[data-cart-upsell]');
        if (upsell) upsell.hidden = !itemCount;
        root.querySelectorAll('[data-checkout]').forEach(function (button) { button.disabled = !itemCount; });
        root.querySelectorAll('[data-cart-accelerated]').forEach(function (element) { element.hidden = !itemCount; });
        if (openAfter) openPanel(cartDrawer);
      } catch (error) {
        if (items) items.innerHTML = '<div class="eipc-cart-empty">Winkelwagen kon niet worden geladen.</div>';
      }
    }

    async function addToCart(button) {
      if (!button || button.disabled) return;
      var variantId = Number(button.dataset.variantId || 0);
      if (!variantId) return;
      var original = button.textContent;
      button.disabled = true;
      if (button.textContent.trim() !== '+') button.textContent = 'Toevoegen…';
      try {
        var response = await fetch(root.dataset.cartAddUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        var added = await response.json();
        var addedLine = added && Array.isArray(added.items) ? added.items[0] : added;
        try { if (window.EmpireCommerceEmit) window.EmpireCommerceEmit('add', {line:addedLine, currency:currency}); } catch (trackingError) {}
        var fallbackCard = button.closest('[data-product-card]') || (productPreviewContent && productPreviewContent._card);
        var item = addedLine && (addedLine.id || addedLine.variant_id)
          ? trackingItemFromCart(addedLine)
          : trackingItemFromCard(fallbackCard, variantId);
        track('eipc_add_to_cart', productEventData(item, 'add_to_cart', 'AddToCart', {
          variant_id:String(variantId),
          source:button.matches('[data-product-preview-add]') ? 'product_preview' : 'collection'
        }));
        toast('Toegevoegd aan je winkelwagen');
        await loadCart(true);
      } catch (error) {
        toast('Toevoegen mislukt. Probeer opnieuw.');
      } finally {
        button.disabled = false;
        button.textContent = original;
      }
    }

    function cleanDescription(html) {
      var parsed = new DOMParser().parseFromString(String(html || ''), 'text/html');
      parsed.querySelectorAll('script,style,iframe,object,embed').forEach(function (element) { element.remove(); });
      parsed.querySelectorAll('*').forEach(function (element) {
        Array.prototype.slice.call(element.attributes).forEach(function (attribute) {
          var unsafeLink = (attribute.name === 'href' || attribute.name === 'src') && /^\s*javascript:/i.test(attribute.value);
          if (/^on/i.test(attribute.name) || unsafeLink) element.removeAttribute(attribute.name);
        });
      });
      return parsed.body.innerHTML;
    }

    function closeProductPreview() {
      if (productDialog && productDialog.open) productDialog.close();
    }

    function updateProductPreviewVariant(variantId) {
      if (!productPreviewContent) return;
      var variants = productPreviewContent._variants || [];
      var variant = variants.find(function (item) { return String(item.id) === String(variantId); }) || variants[0];
      if (!variant) return;
      var price = productPreviewContent.querySelector('[data-product-preview-price]');
      var stock = productPreviewContent.querySelector('[data-product-preview-stock]');
      var add = productPreviewContent.querySelector('[data-product-preview-add]');
      if (price) price.textContent = money(variant.price);
      if (stock) stock.textContent = variant.available ? 'Op voorraad · vandaag verzonden' : 'Tijdelijk uitverkocht';
      if (add) {
        add.dataset.variantId = variant.id;
        add.disabled = !variant.available;
        add.textContent = variant.available ? 'In winkelwagen' : 'Tijdelijk uitverkocht';
      }
    }

    function renderProductPreview(product, card) {
      if (!productPreviewContent) return;
      var meta = cardMeta(card);
      var title = meta.name || product.title;
      var subtitle = meta.sub || '';
      var variants = Array.isArray(product.variants) ? product.variants : [];
      var selected = variants.find(function (variant) { return variant.available; }) || variants[0];
      var images = (product.images || []).map(function (image) {
        return typeof image === 'string' ? image : (image.src || image.url || '');
      }).filter(Boolean);
      if (!images.length && product.featured_image) images.push(typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image.src || product.featured_image.url || ''));
      var mainImage = images[0] || '';
      var media = mainImage
        ? '<div class="eipc-product-preview-main"><img src="' + escapeHtml(mainImage) + '" alt="' + escapeHtml(title) + '" data-product-preview-main></div>'
        : '<div class="eipc-product-preview-main eipc-product-preview-empty">Geen afbeelding</div>';
      var thumbs = images.length > 1 ? '<div class="eipc-product-preview-thumbs">' + images.map(function (image, index) {
        return '<button type="button" data-product-preview-thumb data-image="' + escapeHtml(image) + '" aria-label="Afbeelding ' + (index + 1) + '"><img src="' + escapeHtml(image) + '" alt=""></button>';
      }).join('') + '</div>' : '';
      var variantPicker = variants.length > 1 ? '<label class="eipc-product-preview-picker"><span>Kies uitvoering</span><select data-product-preview-variant>' + variants.map(function (variant) {
        var variantTitle = variant.public_title || variant.title || 'Standaard';
        return '<option value="' + escapeHtml(variant.id) + '"' + (selected && String(selected.id) === String(variant.id) ? ' selected' : '') + (variant.available ? '' : ' disabled') + '>' + escapeHtml(variantTitle) + (variant.available ? '' : ' · uitverkocht') + '</option>';
      }).join('') + '</select></label>' : '';
      var description = cleanDescription(product.description || '');
      productPreviewContent._variants = variants;
      productPreviewContent._product = product;
      productPreviewContent._card = card;
      productPreviewContent.innerHTML = '<div class="eipc-product-preview-media">' + media + thumbs + '</div>' +
        '<div class="eipc-product-preview-info"><span class="eipc-material">Titanium · nikkelvrij</span><h2>' + escapeHtml(title) + '</h2>' +
        (subtitle ? '<p class="eipc-product-preview-sub">' + escapeHtml(subtitle) + '</p>' : '') +
        '<div class="eipc-product-preview-price" data-product-preview-price>' + money(selected ? selected.price : product.price) + '</div>' +
        '<div class="eipc-product-preview-stock" data-product-preview-stock>' + (selected && selected.available ? 'Op voorraad · vandaag verzonden' : 'Tijdelijk uitverkocht') + '</div>' +
        variantPicker +
        '<button class="eipc-btn eipc-btn-primary eipc-product-preview-add" type="button" data-product-preview-add data-variant-id="' + escapeHtml(selected ? selected.id : '') + '"' + (selected && selected.available ? '' : ' disabled') + '>' + (selected && selected.available ? 'In winkelwagen' : 'Tijdelijk uitverkocht') + '</button>' +
        (description ? '<div class="eipc-product-preview-description">' + description + '</div>' : '') +
        '</div>';
    }

    async function openProductPreview(card) {
      if (!card || !productDialog || !productPreviewContent) return;
      var handle = card.dataset.handle;
      if (!handle) return;
      productPreviewContent.innerHTML = '<div class="eipc-product-preview-loading">Product wordt geladen…</div>';
      if (typeof productDialog.showModal === 'function' && !productDialog.open) productDialog.showModal();
      try {
        var product = productCache[handle];
        if (!product) {
          var response = await fetch('/products/' + encodeURIComponent(handle) + '.js', {headers:{Accept:'application/json'}});
          if (!response.ok) throw new Error('product');
          product = await response.json();
          productCache[handle] = product;
        }
        renderProductPreview(product, card);
        var previewItem = trackingItemFromProduct(product, card);
        try {
          if (window.EmpireCommerceEmit) {
            window.EmpireCommerceEmit('view', {site:'shop', product_id:String(product.id), variant_id:String(previewItem.item_id), price:Number(previewItem.price), currency:currency});
          }
        } catch (trackingError) {}
        track('eipc_product_preview_open', productEventData(previewItem, 'view_item', 'ViewContent', {
          product_handle:handle,
          source:'collection_product_preview'
        }));
      } catch (error) {
        productPreviewContent.innerHTML = '<div class="eipc-product-preview-loading"><b>Dit product kon niet worden geladen.</b><br>Probeer het opnieuw.</div>';
      }
    }

    async function changeCart(line, quantity) {
      try {
        var response = await fetch(root.dataset.cartChangeUrl, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:Number(quantity)})});
        if (!response.ok) throw new Error('change');
        await loadCart(false);
      } catch (error) {
        toast('Winkelwagen kon niet worden bijgewerkt.');
      }
    }

    function interceptProductPreview(event) {
      var target = event.target;
      var productPreview = target && target.closest ? target.closest('[data-product-preview]') : null;
      if (!productPreview || !root.contains(productPreview)) return false;
      event.preventDefault();
      event.stopImmediatePropagation();
      openProductPreview(productPreview.closest('[data-product-card]'));
      return true;
    }

    root.addEventListener('click', function (event) {
      interceptProductPreview(event);
    }, true);

    root.addEventListener('auxclick', function (event) {
      if (event.button === 1) interceptProductPreview(event);
    }, true);

    root.addEventListener('click', function (event) {
      var target = event.target;
      var zone = target.closest('[data-zone]');
      if (zone) {
        event.preventDefault();
        var value = zone.dataset.zone;
        if (state.zone.size === 1 && state.zone.has(value)) state.zone.clear();
        else {
          state.zone.clear();
          state.zone.add(value);
        }
        if (MAP_OF[value]) showMap(MAP_OF[value]);
        applyFilters();
        var productsTop = root.querySelector('.eipc-toolbar');
        if (productsTop) productsTop.scrollIntoView({behavior:'smooth', block:'start'});
        track('eipc_map_or_zone_click', {zone:value});
        return;
      }
      var mapTab = target.closest('[data-map-tab]');
      if (mapTab) { showMap(mapTab.dataset.mapTab); return; }
      var productPreview = target.closest('[data-product-preview]');
      if (productPreview) {
        event.preventDefault();
        openProductPreview(productPreview.closest('[data-product-card]'));
        return;
      }
      if (target.closest('[data-product-preview-close]')) { closeProductPreview(); return; }
      var previewThumb = target.closest('[data-product-preview-thumb]');
      if (previewThumb) {
        var previewMain = productPreviewContent && productPreviewContent.querySelector('[data-product-preview-main]');
        if (previewMain) previewMain.src = previewThumb.dataset.image;
        return;
      }
      var previewAdd = target.closest('[data-product-preview-add]');
      if (previewAdd) {
        event.preventDefault();
        closeProductPreview();
        addToCart(previewAdd);
        return;
      }
      var add = target.closest('[data-add-to-cart]');
      if (add) { event.preventDefault(); addToCart(add); return; }
      var wish = target.closest('[data-wish]');
      if (wish) { wish.classList.toggle('is-active'); return; }
      if (target.closest('[data-wishlist-open]')) {
        var wished = root.querySelectorAll('[data-wish].is-active');
        if (wished.length) {
          wished[0].closest('[data-product-card]').scrollIntoView({behavior:'smooth', block:'center'});
          toast(wished.length + (wished.length === 1 ? ' favoriet bewaard' : ' favorieten bewaard'));
        } else toast('Tik op het hartje bij een sieraad om het te bewaren.');
        return;
      }
      if (target.closest('[data-filter-open]')) { openPanel(filterPanel); return; }
      if (target.closest('[data-sort-open]')) { openPanel(sortPanel); return; }
      if (target.closest('[data-cart-open]')) {
        track('eipc_cart_open', currentCart
          ? cartEventData(currentCart, 'view_cart', '', {source:'collection_cart_drawer'})
          : {ga4_event:'view_cart', source:'collection_cart_drawer'});
        loadCart(true);
        return;
      }
      if (target.closest('[data-cart-close]') || target.closest('[data-panel-close]')) { closePanels(); return; }
      if (target.closest('[data-clear]')) { clearFilters(); return; }
      var chip = target.closest('[data-chip-kind]');
      if (chip) {
        var kind = chip.dataset.chipKind;
        if (kind === 'fresh') state.fresh = false;
        else if (kind === 'search') { state.search = ''; root.querySelectorAll('[data-search]').forEach(function (input) { input.value = ''; }); }
        else state[kind].delete(chip.dataset.chipValue);
        applyFilters();
        return;
      }
      if (target.closest('[data-show-more]')) { shown += pageSize; applyFilters(false); return; }
      if (target.closest('[data-scroll-products]')) { root.querySelector('.eipc-toolbar').scrollIntoView({behavior:'smooth', block:'start'}); return; }
      if (target.closest('[data-size-open]')) { if (sizeDialog && typeof sizeDialog.showModal === 'function') sizeDialog.showModal(); return; }
      if (target.closest('[data-size-close]')) { if (sizeDialog) sizeDialog.close(); return; }
      var quantity = target.closest('[data-cart-line]');
      if (quantity) { changeCart(quantity.dataset.cartLine, quantity.dataset.cartQuantity); return; }
      if (target.closest('[data-checkout]')) {
        try { if (window.EmpireCommerceEmit) window.EmpireCommerceEmit('begin', {cart:currentCart}); } catch (trackingError) {}
        track('eipc_begin_checkout', currentCart
          ? cartEventData(currentCart, 'begin_checkout', 'InitiateCheckout', {source:'collection_cart_drawer'})
          : {ga4_event:'begin_checkout', meta_event:'InitiateCheckout', currency:currency, value:0, source:'collection_cart_drawer'});
        window.location.href = '/checkout';
        return;
      }
    });

    root.addEventListener('change', function (event) {
      var input = event.target;
      if (input.matches('[data-filter-field]')) {
        var kind = input.dataset.filterField;
        if (kind === 'fresh') state.fresh = input.checked;
        else if (kind === 'stock') state.stock = input.checked;
        else if (input.checked) state[kind].add(input.value);
        else state[kind].delete(input.value);
        applyFilters();
        track('eipc_filter_used', {filter:kind,value:input.value,active:input.checked});
      }
      if (input.matches('[data-sort]')) { state.sort = input.value; applyFilters(false); }
      if (input.matches('[data-sort-panel] input[type="radio"]')) {
        state.sort = input.value;
        var select = root.querySelector('[data-sort]');
        if (select) select.value = input.value;
        applyFilters(false);
        closePanels();
      }
      if (input.matches('[data-product-preview-variant]')) updateProductPreviewVariant(input.value);
    });

    root.addEventListener('input', function (event) {
      var input = event.target;
      if (input.matches('[data-search]')) {
        state.search = input.value.trim().toLowerCase();
        root.querySelectorAll('[data-search]').forEach(function (other) { if (other !== input) other.value = input.value; });
        applyFilters();
      }
      if (input.matches('[data-price-min]')) { state.min = input.value === '' ? null : Number(input.value); applyFilters(); }
      if (input.matches('[data-price-max]')) { state.max = input.value === '' ? null : Number(input.value); applyFilters(); }
    });

    overlay.addEventListener('click', function () { closePanels(); });
    if (productDialog) productDialog.addEventListener('click', function (event) { if (event.target === productDialog) closeProductPreview(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') closePanels(); });
    var newsletter = root.querySelector('.eipc-newsletter-form');
    if (newsletter) {
      var newsletterMessage = newsletter.querySelector('.eipc-form-message');
      if (newsletterMessage && /^Bedankt\b/i.test(newsletterMessage.textContent.trim())) {
        track('eipc_newsletter_submit', {
          ga4_event:'generate_lead',
          meta_event:'Lead',
          lead_type:'newsletter',
          source:'piercing_collection_newsletter'
        });
      }
    }

    cards().forEach(decorateCard);
    buildCounts();
    syncResponsiveLayout();
    startAnnouncement();
    applyFilters(false);
    loadCart(false);
    loadAllPages();
    if (typeof mobileMedia.addEventListener === 'function') {
      mobileMedia.addEventListener('change', function () {
        syncResponsiveLayout();
        applyFilters(false);
      });
    }
    var listItems = cards().slice(0, pageSize).map(function (card) { return trackingItemFromCard(card); }).filter(Boolean);
    track('eipc_microsite_view', {
      ga4_event:'view_item_list',
      meta_event:'ViewContent',
      collection_handle:'shop',
      product_count:totalProducts,
      currency:currency,
      value:Number(listItems.reduce(function (sum, item) { return sum + Number(item.price || 0); }, 0).toFixed(2)),
      content_type:'product_group',
      content_ids:listItems.map(function (item) { return String(item.item_id); }),
      items:listItems,
      ecommerce:{item_list_id:'piercing_collection', item_list_name:'Piercing collectie', items:listItems}
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-eipc-root]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
})();


